// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","controls":"controls-xbLB2","controls__item":"controls__item-15Wnz","controls__img":"controls__img-1JI3Y"};